import { useState } from 'react';
import { GitFork, ShieldAlert, SquareTerminal } from 'lucide-react';
import { Button } from '../components/UI';
import { useAuthStore } from '../state/authStore';
import styles from './auth.module.css';

function Brand() {
  return <div className={styles.brand}><span className={styles.brandMark}><SquareTerminal size={21} aria-hidden="true" /></span><div><strong>STS2 数据终端</strong><span>RUN_INTEL // ONLINE</span></div></div>;
}

export function SignInPage({ adminPortal = false }: { adminPortal?: boolean }) {
  const { signInWithProvider, error, clearError } = useAuthStore();
  const [busy, setBusy] = useState<string | null>(null);

  const provider = async (name: 'github') => {
    setBusy(name); clearError();
    try { await signInWithProvider(name); }
    finally { setBusy(null); }
  };

  return <main className={styles.page}>
    <section className={styles.hero}>
      <Brand />
      <div className={styles.heroCopy}><span>{adminPortal ? '独立管理入口' : '账号与总体数据'}</span><h1>{adminPortal ? '管理员身份验证。' : '用你的常用账号登录，不必再记一个密码。'}</h1><p>{adminPortal ? '该域名只承载账号管理和管理员代入分析。登录后仍会在服务端验证管理员权限。' : '存档仍在浏览器内解析；导入成功后会自动覆盖同步，每个账号只保留一份数据。'}</p></div>
      <div className={styles.privacy}><strong>隐私边界</strong><span>{adminPortal ? '普通账号即使知道此地址，也无法进入管理员页面或调用管理员数据接口。' : '总体视图不返回邮箱、昵称、原始文件内容或可识别的本地路径。普通入口不包含管理员入口链接。'}</span></div>
    </section>
    <section className={styles.signInPanel} aria-labelledby="signin-title">
      <div className={styles.signInCard}>
        <div><div className={styles.eyebrow}>Secure access</div><h2 id="signin-title">{adminPortal ? '登录管理终端' : '登录数据终端'}</h2><p>通过 GitHub 验证身份；本站不创建、接收或保存密码。</p></div>
        <div className={styles.providers}>
          <Button primary onClick={() => provider('github')} disabled={Boolean(busy)}><GitFork size={16} />{busy === 'github' ? '正在跳转…' : '使用 GitHub 登录'}</Button>
        </div>
        {error && <div className={styles.error} role="alert">{error}</div>}
      </div>
    </section>
  </main>;
}

export function AccountDisabledPage() {
  const { signOut, profile } = useAuthStore();
  return <main className={styles.blocked}><div className={styles.blockedCard}><ShieldAlert size={34} /><h1>账号已停用</h1><p>{profile?.email || '当前账号'} 暂时无法访问数据终端。如需恢复，请联系管理员。</p><Button onClick={() => void signOut()}>退出当前账号</Button></div></main>;
}

export function AdminAccessDeniedPage({ configured }: { configured: boolean }) {
  const { signOut, profile } = useAuthStore();
  return <main className={styles.blocked}><div className={styles.blockedCard}><ShieldAlert size={34} /><h1>无法进入管理终端</h1><p>{configured ? `${profile?.email || '当前账号'} 没有管理员权限。普通用户请使用主站地址。` : '管理员入口需要先启动自建账号服务。'}</p>{configured && <Button onClick={() => void signOut()}>退出当前账号</Button>}</div></main>;
}

export function AuthLoadingPage() {
  return <main className={styles.blocked}><div className={styles.loadingCard}><Brand /><div className={styles.loadingLine} /><p>正在确认登录状态…</p></div></main>;
}
